import Accordion from "./Accordion";
import visual1 from "../../Media/DRC/Visual 1.png";
import visual2 from "../../Media/DRC/Visual 2.png";




const ChartsSection = (props) => {
  
const chartText = {
  drc: [
    {
      title:
        "M23 becomes the most active non-state group in 2023",
      body: visual1,
    },
    {
      title:
        "ADF were the deadliest perpetrators of civilian targeting in 2023",
      body: visual2,
    },
  ],
  haiti: [
    {
      title:
        "Civilians continued to bear the brunt of the violence, prompting heightened response from vigilante groups",
      body: visual1,
    },
    {
      title:
        "Diffusion increased as higher levels of violence were recorded outside Port-au-Prince and the Ouest department in 2023",
      body: visual2,
    },
  ],
  myanmar: [
    {
      title:
        "The military increased its targeting of civilians after sustaining losses during Operation 1027",
      body: visual1,
    },
    {
      title:
        "In battles between the military and resistance groups, joint actions involving more than one resistance group progressively increased in 2023",
      body: visual2,
    },
  ],
  sahel: [
    {
      title:
        "In Mali, violence involving the Wagner Group spiked in 2023",
      body: visual1,
    },
    {
      title:
        "JNIM remained the most active rebel group in the Central Sahel in 2023",
      body: visual2,
    },
  ],
  ukraine: [
    {
      title:
        "Political violence levels remained high in northern Ukraine despite liberation in 2022",
      body: visual1,
    },
    {
      title:
        "Shelling, artillery, and missile attacks remained a constant threat to civilians throughout 2022",
      body: visual2,
    },
  ],
  yemen: [
    {
      title:
        "The share of violence targeting civilians in all political violence spiked in 2023 and reached its highest level since 2015",
      body: visual1,
    },
    {
      title:
        "Violence in the Red Sea spiked in the last quarter of 2023 to the highest levels since 2015, following the outbreak of the Israel-Gaza conflict",
      body: visual2,
    },
  ],
  mexico: [
    {
      title:
        "In 2023, Mexico was the most dangerous country in the world for civilians",
      body: visual1,
    },
    {
      title:
        "Nuevo León, Guanajuato, and Michoacán accounted for 28% of gang violence recorded in 2023",
      body: visual2,
    },
  ],
  palestine: [
    {
      title:
        "Airstrikes perpetrated by the IDF in the last quarter of 2023 were the highest by a single actor in a quarter since 2017",
      body: visual1,
    },
    {
      title:
        "Violence significantly increased in the West Bank in 2023, driven by rising settler violence and armed clashes between Palestinian armed groups and the IDF",
      body: visual2,
    },
  ],
  usa: [
    {
      title:
        "Since the 2020 election, far-right militias have been involved in the vast majority of violent demonstrations over unsubstantiated allegations of voter fraud",
      body: visual1,
    },
    {
      title:
        "White nationalist groups' training sessions reached their highest levels since 2021",
      body: visual2,
    },
  ],
  sudan: [
    {
      title:
        "In 2023, political violence in Sudan reached a record high in August",
      body: visual1,
    },
    {
      title:
        "Since the onset of the war, the Rapid Support Forces were responsible for most violence targeting civilians in Darfur in 2023",
      body: visual2,
    },
  ],
};
const dataForAccordion = chartText[props.focusCountry];
  return (
    <div
      style={{
        width: "100%",
        height: props.height,
        boxSizing: "border-box",
      }}
    >
      <Accordion dataForAccordion={dataForAccordion} height={props.height} focusCountry={props.focusCountry} />
    </div>
  );
};

export default ChartsSection;
